<template>
  <b-skeleton-wrapper :loading="HEADER_LOADING">
    <template #loading>
      <b-row
        class="margin-0 evidence-card"
        v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
        :key="index"
      >
        <b-col cols="12" class="padding-0 evidence-card__top-box">
          <b-skeleton width="80%"></b-skeleton>
          <div class="evidence-card__option-box">
            <b-skeleton height="25px" type="button"></b-skeleton>

            <span class="evidence-card__option-icon">
              <b-skeleton width="3%" type="button"></b-skeleton>
            </span>
          </div>
        </b-col>
        <b-col cols="12" class="padding-0 evidence-card__bottom-box">
          <div class="evidence-card__bottom-box-right">
            <b-skeleton width="75%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
          </div>
          <div class="evidence-card__bottom-box-left">
            <b-skeleton width="75%"></b-skeleton>
            <b-skeleton width="100%"></b-skeleton>
          </div>
        </b-col>
      </b-row>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  inject: ["HEADER_LOADING"],
};
</script>
